import React from "react";
import RoomComponent from "./RoomComponent/RoomComponent";

export default class House extends React.Component {
    constructor( props ) {
        super(props);
    }

    render() {
        let state = this.props.state;

        if ( state == null ) {
            return <div></div>;
        }

        return <div className="app">
            {state?.storylineState !== null &&
            <div className="app-container">
                {!( state?.storylineState?.hasRoomLoaded ?? false ) &&
                <div class="loading-screen"></div>
                }

                {( state?.storylineState?.hasRoomLoaded ?? false ) &&
                <RoomComponent storylineState={state.storylineState}></RoomComponent>
                }
            </div>
            }
        </div>;
    }
}
